import { render, staticRenderFns } from "./FilterPatientName.vue?vue&type=template&id=2a12579d&lang=pug&"
import script from "./FilterPatientName.vue?vue&type=script&lang=js&"
export * from "./FilterPatientName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports